import axios from 'axios';
import { 
  Guild, 
  UserData, 
  Status, 
  Language, 
  ClientLanguage,
  Control
 } from './types'
import data from '../data/config.json'
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const auth_cookies = cookies.get('connect.dreamvast')

console.log("Api " + auth_cookies)

axios.defaults.withCredentials = true

const API_URL = `${data.api_url}`

export const getAuthStatus = () => 
  axios.get<Status>(`${API_URL}/auth/status`, {
    headers: { Authorization: `${auth_cookies ? auth_cookies : null}` }
  });

export const getGuilds = () => 
  axios.get<Guild[]>(`${API_URL}/guilds`, {
    headers: { Authorization: `${auth_cookies ? auth_cookies : null}` }
  })

export const getGuildLang = (id: string) => 
  axios.get<Language>(`${API_URL}/guilds/${id}/settings/language`, {
    headers: { Authorization: `${auth_cookies ? auth_cookies : null}` }
  })

export const getGuildControl = (id: string) =>
  axios.get<Control>(`${API_URL}/guilds/${id}/settings/control`, {
    headers: { Authorization: `${auth_cookies ? auth_cookies : null}` }
  })

export const getUser = () => 
  axios.get<UserData>(`${API_URL}/users/@me`, {
    headers: { Authorization: `${auth_cookies ? auth_cookies : null}` }
  })

export const getClientLang = () =>
  axios.get<ClientLanguage>(`${API_URL}/client/language`, {
    headers: { Authorization: `${auth_cookies ? auth_cookies : null}` }
  })

export const getPlayerGuilds = () =>
  axios.get<Guild[]>(`${API_URL}/guilds/user`, {
    headers: { Authorization: `${auth_cookies ? auth_cookies : null}` }
  })
